"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[956],{

/***/ 2690:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6042);
/* harmony import */ var _home_runner_work_refferal_frontend_refferal_frontend_lib_refferal_next_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _home_runner_work_refferal_frontend_refferal_frontend_lib_refferal_next_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_refferal_frontend_refferal_frontend_lib_refferal_next_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ssr_user__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4765);
/* provided dependency */ var process = __webpack_require__(3454);





var _NEXT_PUBLIC_API_BASEPATH;
var basePath = (_NEXT_PUBLIC_API_BASEPATH = process.env.NEXT_PUBLIC_API_BASEPATH) !== null && _NEXT_PUBLIC_API_BASEPATH !== void 0 ? _NEXT_PUBLIC_API_BASEPATH : "https://referral-backend.network.seeblindspot.com/";
// const basePath = 'http://localhost:8000/v1';
var API = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_home_runner_work_refferal_frontend_refferal_frontend_lib_refferal_next_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(request, otherOption) {
        var options, client, jwt;
        return _home_runner_work_refferal_frontend_refferal_frontend_lib_refferal_next_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    options = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                        baseURL: basePath,
                        timeout: 60000
                    }, otherOption);
                    if (request.cancelToken) options.cancelToken = request.cancelToken;
                    client = axios__WEBPACK_IMPORTED_MODULE_1___default().create(options);
                    _ctx.next = 5;
                    return (0,_ssr_user__WEBPACK_IMPORTED_MODULE_2__/* .getUser */ .P)();
                case 5:
                    jwt = _ctx.sent;
                    if (jwt) client.defaults.headers.common["Authorization"] = "Bearer ".concat(jwt);
                    return _ctx.abrupt("return", client.request(request));
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function API(request, otherOption) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["Z"] = (API);


/***/ }),

/***/ 6123:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var nookies__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2286);
/* harmony import */ var nookies__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(nookies__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var jwt_decode__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6245);
/* harmony import */ var logrocket__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9258);
/* harmony import */ var logrocket__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(logrocket__WEBPACK_IMPORTED_MODULE_2__);



var maxAge = 30 * 24 * 60 * 60;
var setJwt = function(response) {
    if (response.token) (0,nookies__WEBPACK_IMPORTED_MODULE_0__.setCookie)(null, "jwt", response.token, {
        maxAge: maxAge,
        path: "/"
    });
    if (response.email) (0,nookies__WEBPACK_IMPORTED_MODULE_0__.setCookie)(null, "email", response.email, {
        maxAge: maxAge,
        path: "/"
    });
    (0,nookies__WEBPACK_IMPORTED_MODULE_0__.setCookie)(null, "user", "1", {
        maxAge: maxAge,
        path: "/"
    });
    if (response.token) {
        var jwt = (0,jwt_decode__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(response.token);
        var l = {
            email: jwt.email
        };
        return l;
    } else {
        var l1 = {
            email: response.email
        };
        return l1;
    }
};
var getJwtUser = function() {
    var cookies = (0,nookies__WEBPACK_IMPORTED_MODULE_0__.parseCookies)();
    var jwt = cookies.jwt;
    if (jwt) {
        var jwtDecode = (0,jwt_decode__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(jwt);
        var l = {
            email: jwtDecode.email
        };
        logrocket__WEBPACK_IMPORTED_MODULE_2___default().identify(jwtDecode.email, {
            name: "USER",
            email: jwtDecode.email,
            role: "USER"
        });
        return l;
    } else {
        var l1 = {
            email: cookies.email
        };
        return l1;
    }
};
var JWT = {
    setJwt: setJwt,
    getJwtUser: getJwtUser
};
/* harmony default export */ __webpack_exports__["Z"] = (JWT);


/***/ }),

/***/ 4765:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ getUser; },
/* harmony export */   "z": function() { return /* binding */ checkUser; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7568);
/* harmony import */ var _home_runner_work_refferal_frontend_refferal_frontend_lib_refferal_next_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _home_runner_work_refferal_frontend_refferal_frontend_lib_refferal_next_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_refferal_frontend_refferal_frontend_lib_refferal_next_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var nookies__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2286);
/* harmony import */ var nookies__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(nookies__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var jwt_decode__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6245);
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(120);






var checkUser = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_home_runner_work_refferal_frontend_refferal_frontend_lib_refferal_next_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var cookies, url, jwtDecode, l;
        return _home_runner_work_refferal_frontend_refferal_frontend_lib_refferal_next_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    cookies = (0,nookies__WEBPACK_IMPORTED_MODULE_2__.parseCookies)();
                    url = "";
                    if ((next_router__WEBPACK_IMPORTED_MODULE_1___default().pathname)) {
                        url = (next_router__WEBPACK_IMPORTED_MODULE_1___default().pathname);
                    }
                    if (cookies.email) {
                        _ctx.next = 6;
                        break;
                    }
                    next_router__WEBPACK_IMPORTED_MODULE_1___default().push("/auth/login");
                    return _ctx.abrupt("return", null);
                case 6:
                    if (cookies.email && !cookies.jwt) {
                        if (!url.includes("auth")) {
                            next_router__WEBPACK_IMPORTED_MODULE_1___default().push("/auth/validate-email");
                        }
                    }
                    if (!(cookies.email && cookies.jwt)) {
                        _ctx.next = 14;
                        break;
                    }
                    if (url.includes("auth")) {
                        next_router__WEBPACK_IMPORTED_MODULE_1___default().push("/");
                    }
                    jwtDecode = (0,jwt_decode__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(cookies.jwt);
                    l = {
                        email: jwtDecode.email || "-"
                    };
                    return _ctx.abrupt("return", l);
                case 14:
                    return _ctx.abrupt("return", null);
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function checkUser() {
        return _ref.apply(this, arguments);
    };
}();
var getUser = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_home_runner_work_refferal_frontend_refferal_frontend_lib_refferal_next_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var cookies, decodedToken, now, expirationDate, diff;
        return _home_runner_work_refferal_frontend_refferal_frontend_lib_refferal_next_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    cookies = (0,nookies__WEBPACK_IMPORTED_MODULE_2__.parseCookies)();
                    if (!cookies.jwt) {
                        _ctx.next = 13;
                        break;
                    }
                    decodedToken = (0,jwt_decode__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(cookies.jwt);
                    now = luxon__WEBPACK_IMPORTED_MODULE_4__/* .DateTime.local */ .ou.local();
                    expirationDate = luxon__WEBPACK_IMPORTED_MODULE_4__/* .DateTime.fromSeconds */ .ou.fromSeconds(decodedToken.exp);
                    diff = expirationDate.diff(now, [
                        "seconds"
                    ]);
                    if (!(diff.seconds < 30)) {
                        _ctx.next = 10;
                        break;
                    }
                    return _ctx.abrupt("return", null);
                case 10:
                    return _ctx.abrupt("return", cookies.jwt);
                case 11:
                    _ctx.next = 14;
                    break;
                case 13:
                    return _ctx.abrupt("return", null);
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getUser() {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 8663:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var common_tags__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(865);





function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "bg-primary-500 border-primary-500 hover:shadow-primaryFullHover focus:shadow-primaryFullHover"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "text-primary-500 bg-white border-primary-500 hover:shadow-primaryOutlineHover focus:shadow-primaryOutlineHover"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "text-primary-500 dark:bg-dark-200 bg-white border-primary-500 hover:shadow-primaryOutlineHover focus:shadow-primaryOutlineHover"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "text-primary-500 hover:text-primary-600 focus:text-primary-600 border-0"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "bg-lightGrey dark:bg-dark-500 dark:border-none hover:shadow-secondaryFullHover focus:shadow-secondaryFullHover"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "text-primarydark-default bg-dark-200 border-bordercolorprimary hover:shadow-primaryOutlineHover focus:shadow-primaryOutlineHover"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "text-lightGrey hover:text-grey-300 focus:text-grey-300 border-0"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "bg-dark-500 dark:bg-dark-400 dark:bg-opacity-30 dark:border-none hover:shadow-tertiaryFullHover focus:shadow-tertiaryFullHover"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "text-dark-500 bg-white border-dark-500 hover:shadow-tertiaryOutlineHover focus:shadow-tertiaryOutlineHover"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "text-dark-500 dark:text-bordercolordark hover:text-dark-600 focus:text-dark-600 border-0"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "text-white hover:text-white focus:text-white border-0"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "bg-accent-500 text-primary-400 hover:bg-accent-300 active:bg-accent-700"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "text-accent-600 bg-transparent border-accent-500 hover:bg-primary-500 hover:bg-contrast-500 active:bg-contrast-400 border-2"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "text-accent-600 hover:bg-contrast-200 active:bg-contrast-300"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "bg-danger-500 text-white hover:bg-danger-600 active:bg-danger-700"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "text-danger-500 bg-transparent border-2 border-danger-500 hover:bg-contrast-500 active:bg-contrast-400"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "text-danger-600 hover:bg-contrast-200 active:bg-contrast-300"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          flex items-center justify-center\n          ",
        "\n          ",
        "\n          ",
        "\n          ",
        "\n          ",
        " \n          ",
        "\n          ",
        "\n        "
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}


// @ts-ignore
// import { Iconly } from 'react-iconly';

var Size = {
    md: "btn-base",
    lg: "btn-base large",
    sm: "btn-base small"
};
var Style = {
    primary: {
        full: (0,common_tags__WEBPACK_IMPORTED_MODULE_3__/* .oneLine */ .f9)(_templateObject()),
        outline: (0,common_tags__WEBPACK_IMPORTED_MODULE_3__/* .oneLine */ .f9)(_templateObject1()),
        outlinedark: (0,common_tags__WEBPACK_IMPORTED_MODULE_3__/* .oneLine */ .f9)(_templateObject2()),
        none: (0,common_tags__WEBPACK_IMPORTED_MODULE_3__/* .oneLine */ .f9)(_templateObject3())
    },
    secondary: {
        full: (0,common_tags__WEBPACK_IMPORTED_MODULE_3__/* .oneLine */ .f9)(_templateObject4()),
        outline: (0,common_tags__WEBPACK_IMPORTED_MODULE_3__/* .oneLine */ .f9)(_templateObject5()),
        outlinedark: "text-primary-500 dark:bg-dark-200 bg-white border-primary-500 hover:shadow-primaryOutlineHover focus:shadow-primaryOutlineHover",
        none: (0,common_tags__WEBPACK_IMPORTED_MODULE_3__/* .oneLine */ .f9)(_templateObject6())
    },
    tertiary: {
        full: (0,common_tags__WEBPACK_IMPORTED_MODULE_3__/* .oneLine */ .f9)(_templateObject7()),
        outline: (0,common_tags__WEBPACK_IMPORTED_MODULE_3__/* .oneLine */ .f9)(_templateObject8()),
        outlinedark: "",
        none: (0,common_tags__WEBPACK_IMPORTED_MODULE_3__/* .oneLine */ .f9)(_templateObject9())
    },
    white: {
        full: "bg-white dark:bg-dark-700 border-0",
        outline: "",
        outlinedark: "",
        none: (0,common_tags__WEBPACK_IMPORTED_MODULE_3__/* .oneLine */ .f9)(_templateObject10())
    },
    accent: {
        full: (0,common_tags__WEBPACK_IMPORTED_MODULE_3__/* .oneLine */ .f9)(_templateObject11()),
        outline: (0,common_tags__WEBPACK_IMPORTED_MODULE_3__/* .oneLine */ .f9)(_templateObject12()),
        outlinedark: "",
        none: (0,common_tags__WEBPACK_IMPORTED_MODULE_3__/* .oneLine */ .f9)(_templateObject13())
    },
    danger: {
        full: (0,common_tags__WEBPACK_IMPORTED_MODULE_3__/* .oneLine */ .f9)(_templateObject14()),
        outline: (0,common_tags__WEBPACK_IMPORTED_MODULE_3__/* .oneLine */ .f9)(_templateObject15()),
        outlinedark: "",
        none: (0,common_tags__WEBPACK_IMPORTED_MODULE_3__/* .oneLine */ .f9)(_templateObject16())
    }
};
var Button = function(_param) {
    var children = _param.children, _type = _param.type, type = _type === void 0 ? "button" : _type, _tag = _param.tag, tag = _tag === void 0 ? "button" : _tag, _buttonSize = _param.buttonSize, buttonSize = _buttonSize === void 0 ? "md" : _buttonSize, _fill = _param.fill, fill = _fill === void 0 ? "full" : _fill, _color = _param.color, color = _color === void 0 ? "primary" : _color, _fullWidth = _param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth, className = _param.className, disabled = _param.disabled, loading = _param.loading, icon = _param.icon, innerRef = _param.innerRef, simulateBtn = _param.simulateBtn, justIcon = _param.justIcon, otherProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "children",
        "type",
        "tag",
        "buttonSize",
        "fill",
        "color",
        "fullWidth",
        "className",
        "disabled",
        "loading",
        "icon",
        "innerRef",
        "simulateBtn",
        "justIcon"
    ]);
    var Tag = tag;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_2__.useState(false), 2), isLoading = ref[0], setIsLoading = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (loading || loading === false) setIsLoading(loading);
    }, [
        loading
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Tag, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        type: type,
        ref: innerRef,
        className: (0,common_tags__WEBPACK_IMPORTED_MODULE_3__/* .oneLine */ .f9)(_templateObject17(), !simulateBtn ? "font-button  font-bold" : " font-medium", fullWidth ? "w-full" : "w-fit", Style[color][fill], className ? className : "", Size[buttonSize], justIcon ? "just-icon" : "", disabled ? "opacity-30 pointer-events-none" : "")
    }, otherProps), {
        children: [
            isLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
                className: "animate-spin -ml-1 mr-3 h-5 w-5 text-white",
                xmlns: "http://www.w3.org/2000/svg",
                fill: "none",
                viewBox: "0 0 24 24",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("circle", {
                        className: "opacity-25",
                        cx: "12",
                        cy: "12",
                        r: "10",
                        stroke: "currentColor",
                        strokeWidth: "4"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                        className: "opacity-75",
                        fill: "currentColor",
                        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    })
                ]
            }),
            children
        ]
    }));
};
Button.defaultProps = {
    type: "button",
    fill: "full",
    buttonSize: "md",
    loading: false
};
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 7134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var nookies__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2286);
/* harmony import */ var nookies__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(nookies__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var api_ssr_jwt__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6123);


// import { ChevronLeft } from 'react-iconly';



var Navbar = function(param) {
    var title = param.title, logout = param.logout;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), email = ref[0], setEmail = ref[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var onClickHandle = function() {
        nookies__WEBPACK_IMPORTED_MODULE_2___default().destroy(null, "user", {
            path: "/"
        });
        nookies__WEBPACK_IMPORTED_MODULE_2___default().destroy(null, "email", {
            path: "/"
        });
        nookies__WEBPACK_IMPORTED_MODULE_2___default().destroy(null, "jwt", {
            path: "/"
        });
        router.push("/auth/login");
    };
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        if (api_ssr_jwt__WEBPACK_IMPORTED_MODULE_4__/* ["default"].getJwtUser */ .Z.getJwtUser()) {
            setEmail(api_ssr_jwt__WEBPACK_IMPORTED_MODULE_4__/* ["default"].getJwtUser */ .Z.getJwtUser().email);
        }
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "flex-shrink-0 min-h-24 bg-dark-200",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex flex-row items-center min-h-24 px-7 tablet:px-4 py-5 md:pr-7 justify-between flex-wrap",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex flex-row",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-32 mobile:w-20",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: "/images/logo-blindspot-darkmode.svg",
                                width: "280",
                                height: "115",
                                alt: "Blindspot"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "items-center hidden text-xl text-white border-l-2 ml-7 border-dark-300 border-opacity-40 pl-7 md:flex",
                            dangerouslySetInnerHTML: {
                                __html: title
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex-1",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex items-center tablet:items-end justify-end tablet:flex-col",
                        children: [
                            logout && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                        className: "tablet:hidden mr-3 text-dark-300",
                                        children: "Connected with:"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "mr-4 text-dark-300 tablet:mr-0 text-center bg-lightGrey bg-opacity-20 px-2 py-1 rounded-xl tablet:bg-dark-200 tablet:px-0",
                                        children: email
                                    })
                                ]
                            }),
                            !logout && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                className: "mr-4 text-dark-300 tablet:mr-0 text-center",
                                children: "Need more information about us?"
                            }),
                            !logout && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: "https://seeblindspot.com/",
                                target: "_blank",
                                rel: "noreferrer",
                                className: "font-semibold text-primarydark-default",
                                children: "Visit our website"
                            }),
                            logout && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                onClick: onClickHandle,
                                className: "font-semibold text-primarydark-default cursor-pointer",
                                children: "Logout"
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Navbar);


/***/ }),

/***/ 743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ getErrorMessage; }
/* harmony export */ });
var messages = {
    AccountUpdated: "The Account has been updated",
    EmailAlreadyInDatabase: "Email taken",
    EmailNotificationSent: "The Account has been updated. An email was send to validate the request",
    EmailUpdated: "The email has been changed",
    PasswordDifferent: "The old password you have entered is incorrect",
    PasswordChanged: "Your password has been changed"
};
var getErrorMessage = function(e) {
    var message = "try again later";
    try {
        if (e && e.response && e.response.data) {
            var errorData = e.response.data;
            if (Array.isArray(errorData) && errorData[0] && errorData[0].error && Object.values(errorData[0].error)[0]) {
                message = Object.values(errorData[0].error)[0];
            } else {
                message = errorData.error || errorData.message || errorData.msg || errorData.errMessage || errorData;
            }
        }
        // eslint-disable-next-line no-console
        return messages[message] || message;
    } catch (error) {
        console.log(error);
    }
};


/***/ })

}]);